var chromeExtension = "ioajglkpoiippgegmbnickbpknbahigp";
var productID = "com.cfca.certenrollment.cofco";

var extensionName = productID + ".extension";
var reqEventName  = productID + ".request";
var respEventName = productID + ".response";

var Browser = {
    IE:      "Internet Explorer",
    Edge:    "Edge",
    Chrome:  "Chrome",
    Safari:  "Safari",
    Firefox: "Firefox",
};
import errorMap from '../cfca/cryptokit/sendMsg/errorMap'
function errorHandler(err){
    let {result} = err
    console.log(result)
    if(!result) return
    for(let key in errorMap){
      let msg = errorMap[key]
      let isIn = result.includes(key)
      if(isIn){
        err.result = msg
      }
    }
}
const getLastErrorDesc = function () {
    var request = new Object();
    var funcInfo = new Object();
    var randomId = GenerateRandomId();

    funcInfo.function = "GetLastErrorDesc";
    funcInfo.params = null;
    funcInfo.randomId = randomId;

    request.action = "invoke";
    request.funcInfo = funcInfo;

    return SendMessage('Chrome', request);
}

// Encapsulate Chrome sendMessage callback to Promise
function SendMessageforChrome(request) {
    return new Promise( function (resolve, reject) {
        if(chrome.runtime&&chrome.runtime.sendMessage) {
            chrome.runtime.sendMessage(chromeExtension, request, function (response) {
                if (response) {
                    if(0 == response.errorcode){ 
                        resolve(response);                                    
                    }else{
                        // errorHandler(response)
                        // console.log(response)
                        // reject(response)
                        if(response.errorcode == 1) {
                            errorHandler(response)
                            reject(response)
                          }else{
                            return getLastErrorDesc().then((res) => {
                              errorHandler(res)
                              reject(res)
                            })
                          }
                    }
                }else {
                    reject({errorcode:1, result: '验证失败，请确保插件已安装并打开'})
                }
            });
        }else{
            reject({errorcode:1, result: '验证失败，请确保插件已安装并打开'})
        }
        
    });
}

// Encapsulate Edge&Firefox event to Promise
function SendMessagebyEvent(request) {
    var event = new CustomEvent(reqEventName, { detail: request });
    document.dispatchEvent(event);

    return new Promise( function (resolve, reject) {
	
	    var responseEventName = respEventName;
	    if(request.funcInfo != undefined && request.funcInfo.randomId != undefined)
			responseEventName += ("." + request.funcInfo.randomId);
			
        document.addEventListener(responseEventName, function CallBack(e) {
            document.removeEventListener(e.type, CallBack);
            var eJson = JSON.parse(e.detail);
            if (null != eJson && 0 == eJson.errorcode) {
                resolve(eJson);
            }
            else {
                reject(eJson);
            }
        }, false);
    });
}

function SendMessage(browser, requestJSON) {
    if (Browser.Chrome == browser) {
        return SendMessageforChrome(requestJSON);
    }
    else {
        return SendMessagebyEvent(requestJSON);
    }
}


function checkExtension (browser) {
    return new Promise(function (resolve, reject) {
        var result = new Object();
        if (Browser.Chrome == browser) {
            resolve(browser);
        }else if (Browser.Edge == browser || Browser.Firefox == browser) {
            if (document.getElementById(extensionName)) {
                resolve(browser);
            }else {
                result.errorcode = 1;
                result.result = "Extension does not exist!";
                reject(result);
            }
        }else {
            result.errorcode = 1;
            result.result = "Only support Chrome/Edge/Firefox";
            reject(result);
        }
    });
}

export function nmCryptokit(browser) {

    this.browser = browser;
};

function GenerateRandomId() {
    var charstring = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890';
    var maxPos = charstring.length;
    var randomId = '';
    for (let i = 0; i < 10; i++) {
        randomId += charstring.charAt(Math.floor(Math.random() * maxPos));
    }
    return randomId;
}
	
nmCryptokit.prototype.init = function () {

    var browser = this.browser;

    return checkExtension(browser)
        .then(function (browser) {
            var request = new Object();
            request.action = "connect";
            request.host = productID;
            return SendMessage(browser, request);
        }).then(function () {
            var request = new Object();
            request.action = "checkHost";
            return SendMessage(browser, request);
        });
}


nmCryptokit.prototype.uninit = function () {

    var request = new Object();                   
    request.action = "disconnect";
    request.host = productID;

    return SendMessage(this.browser, request);
}


nmCryptokit.prototype.CFCA_GetCSPInfo = function () {

    var request = new Object();
    var funcInfo = new Object();
    var paramArr = new Array();
    var randomId = GenerateRandomId();
           
    funcInfo.function = "CFCA_GetCSPInfo";
    funcInfo.params = paramArr;
    funcInfo.randomId = randomId;
       
    request.action = "invoke";
    request.funcInfo = funcInfo;

    return SendMessage(this.browser, request);
}


nmCryptokit.prototype.CFCA_SetCSPInfo = function (lKeyLength, bstrCSPName) {
          
    var request = new Object();
    var funcInfo = new Object();
    var paramArr = new Array();
    var randomId = GenerateRandomId();
    
    paramArr.push(lKeyLength);
    paramArr.push(bstrCSPName);
       
    funcInfo.function = "CFCA_SetCSPInfo";
    funcInfo.params = paramArr;
    funcInfo.randomId = randomId;
       
    request.action = "invoke";
    request.funcInfo = funcInfo;

    return SendMessage(this.browser, request);
}


nmCryptokit.prototype.CFCA_SetKeyAlgorithm = function (bstrKeyAlgorithm) {

    var request = new Object();
    var funcInfo = new Object();
    var paramArr = new Array();
    var randomId = GenerateRandomId();
    
    paramArr.push(bstrKeyAlgorithm);
       
    funcInfo.function = "CFCA_SetKeyAlgorithm";
    funcInfo.params = paramArr;
    funcInfo.randomId = randomId;
       
    request.action = "invoke";
    request.funcInfo = funcInfo;

    return SendMessage(this.browser, request);
}


nmCryptokit.prototype.CFCA_ImportEncryptCert = function (bstrEncryptedPrivateKey, bstrP7Cert, bstrContainerName, lEncryptCertPrivateKeyFlags) {

    var request = new Object();
    var funcInfo = new Object();
    var paramArr = new Array();
    var randomId = GenerateRandomId();

    paramArr.push(bstrEncryptedPrivateKey);
    paramArr.push(bstrP7Cert);
    paramArr.push(bstrContainerName);
    paramArr.push(lEncryptCertPrivateKeyFlags);

    funcInfo.function = "CFCA_ImportEncryptCert";
    funcInfo.params = paramArr;
    funcInfo.randomId = randomId;
       
    request.action = "invoke";
    request.funcInfo = funcInfo;

    return SendMessage(this.browser, request);
}


nmCryptokit.prototype.CFCA_GetContainer = function () {

    var request = new Object();
    var funcInfo = new Object();
    var paramArr = new Array();
    var randomId = GenerateRandomId();
       
    funcInfo.function = "CFCA_GetContainer";
    funcInfo.params = paramArr;
    funcInfo.randomId = randomId;
       
    request.action = "invoke";
    request.funcInfo = funcInfo;

    return SendMessage(this.browser, request);
}


nmCryptokit.prototype.CFCA_ImportSignCert = function (lCertType, bstrSignCert, bstrContainerName) {
    var request = new Object();
    var funcInfo = new Object();
    var paramArr = new Array();
    var randomId = GenerateRandomId();

    paramArr.push(lCertType);
    paramArr.push(bstrSignCert);
    paramArr.push(bstrContainerName);
       
    funcInfo.function = "CFCA_ImportSignCert";
    funcInfo.params = paramArr;
    funcInfo.randomId = randomId;
       
    request.action = "invoke";
    request.funcInfo = funcInfo;

    return SendMessage(this.browser, request);
}


nmCryptokit.prototype.CFCA_PKCS10CertRequisition = function (bstrSubjectDN, lCertType, lSignPrivateKeyGenerateFlags) {

    var request = new Object();
    var funcInfo = new Object();
    var paramArr = new Array();
    var randomId = GenerateRandomId();

    paramArr.push(bstrSubjectDN);
    paramArr.push(lCertType);
    paramArr.push(lSignPrivateKeyGenerateFlags);
       
    funcInfo.function = "CFCA_PKCS10CertRequisition";
    funcInfo.params = paramArr;
    funcInfo.randomId = randomId;
       
    request.action = "invoke";
    request.funcInfo = funcInfo;

    return SendMessage(this.browser, request);
}


nmCryptokit.prototype.CFCA_GetAllCertInfo = function () {

    var request = new Object();
    var funcInfo = new Object();
    var paramArr = new Array();
    var randomId = GenerateRandomId();

    funcInfo.function = "CFCA_GetAllCertInfo";
    funcInfo.params = paramArr;
    funcInfo.randomId = randomId;
       
    request.action = "invoke";
    request.funcInfo = funcInfo;

    return SendMessage(this.browser, request);
}


nmCryptokit.prototype.CFCA_GetVersion = function () {

    var request = new Object();
    var funcInfo = new Object();
    var paramArr = new Array();
    var randomId = GenerateRandomId();
           
    funcInfo.function = "CFCA_GetVersion";
    funcInfo.params = paramArr;
    funcInfo.randomId = randomId;
       
    request.action = "invoke";
    request.funcInfo = funcInfo;

    return SendMessage(this.browser, request);
}


nmCryptokit.prototype.GetLastErrorDesc = function () {

    var request = new Object();
    var funcInfo = new Object();
    var randomId = GenerateRandomId();

    funcInfo.function = "GetLastErrorDesc";
    funcInfo.params = null;
    funcInfo.randomId = randomId;

    request.action = "invoke";
    request.funcInfo = funcInfo;

    return SendMessage(this.browser, request);
}


// WEBPACK FOOTER //
// ./apps/cfcaclass/nmCertEnrollment.COFCO.js